"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVIEW_LAYOUTS = exports.REVIEW_WHO_ALL = void 0;
exports.isShownForWho = isShownForWho;
exports.reviewersOfPerson = reviewersOfPerson;
// D6 (workflow review 2026-10-29, DECISIONS-LOG 2026-11-01 Q7, ADR 0080) — ④ Review as a list. HR reviews first (`review_status`),
// then the job's hiring manager does their own review: the existing manager response on the shortlist (§L31). No new state; the
// list only shows who made each review and filters by it.
/**
 * The list's filter (evening review 2026-11-01 item 8, which replaced "HR's picks / Mine / All"): everyone, or the people one
 * reviewer reviewed, by that reviewer's user id. Every reviewer is offered by name: HR, the team lead, guests, anyone.
 */
exports.REVIEW_WHO_ALL = 'all';
/** The two ways ④ Review is drawn; the list is the default and each person's choice is remembered. */
exports.REVIEW_LAYOUTS = ['list', 'board'];
/**
 * Whether a person in review shows under a filter (ADR 0080 §2, evening review item 8):
 * - **All**: everyone in review on the job.
 * - **Reviewed by someone**: that person made one of the reviews: set the current Shortlisted or Maybe, or gave the manager's Yes or No.
 */
function isShownForWho(who, row, person) {
    if (who === exports.REVIEW_WHO_ALL)
        return true;
    return reviewersOfPerson(row, person).some((reviewer) => reviewer.userId === who);
}
/** Who reviewed one person: HR's review while it stands (Shortlisted or Maybe), and the manager's Yes or No. Each person once. */
function reviewersOfPerson(row, person) {
    const found = [];
    const hr = person?.reviewedBy;
    if (hr?.userId && row.reviewStatus !== null && row.reviewStatus !== 'to_review')
        found.push({ userId: hr.userId, name: hr.name });
    const manager = person?.managerReviewedBy;
    if (manager?.userId && (row.managerResponse === 'yes' || row.managerResponse === 'no') && !found.some((r) => r.userId === manager.userId)) {
        found.push({ userId: manager.userId, name: manager.name });
    }
    return found;
}
//# sourceMappingURL=review-list.js.map